import script from "./BadgeCelebration.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgeCelebration.vue?vue&type=script&setup=true&lang=js"

import "./BadgeCelebration.vue?vue&type=style&index=0&id=8ec6ce8a&scoped=true&lang=css"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ec6ce8a"]])

export default __exports__